import type {Vehicle} from "../types";

/**
 * Resolves household id from API shapes:
 * - `house_hold_id` on the vehicle root
 * - `house_hold.house_hold_id` (common on list/detail)
 * - `resident.house_hold.id` when full user embed is present
 */
export function getVehicleHouseholdId(vehicle: Vehicle | null | undefined): number | null {
  if (!vehicle) return null;
  if (vehicle.house_hold_id != null && vehicle.house_hold_id !== 0) {
    return vehicle.house_hold_id;
  }
  const fromEmbed = vehicle.house_hold?.house_hold_id;
  if (fromEmbed != null && fromEmbed !== 0) return fromEmbed;
  const fromResident = vehicle.resident?.house_hold?.id;
  if (fromResident != null && fromResident !== 0) return fromResident;
  return null;
}
